import styled from 'styled-components';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';

const MATCH_CATEGORY_ORDER = ['Very High', 'High', 'Medium', 'Low'];

const CATEGORY_COLORS: Record<string, string> = {
  'Very High': FullPalette.GREEN_700,
  High: FullPalette.GREEN_600,
  Medium: FullPalette.GREY_900,
  Low: FullPalette.GREY_600,
};

export const matchCategoryColor = (category?: string | null): string =>
  (category && CATEGORY_COLORS[category]) || FullPalette.GREY_900;

export const matchCategoryRank = (category?: string | null): number => {
  const index = category ? MATCH_CATEGORY_ORDER.indexOf(category) : -1;
  return index === -1 ? MATCH_CATEGORY_ORDER.length : index;
};

export const CategoryValue = styled(SecondaryBody)<{ $color: string }>`
  color: ${({ $color }) => $color};
  font-weight: 600;
  white-space: nowrap;
`;
